import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { translate } from 'translations/i18n';

import { ChipToggle, Spinner } from '@companycam/slab-web';
import { truncateText } from 'helpers/strings';

import { useProjectTags } from './hooks';

const TagRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--cc_size_spacing_xs);
  padding-bottom: ${(props) =>
    props.hasTags ? 'var(--cc_size_spacing_m)' : '0'};
`;

const TagRow = ({ projectId, activeFilterTags, onChange }) => {
  const { isLoadingTags, tags } = useProjectTags(projectId);

  if (isLoadingTags) {
    return (
      <Spinner
        size={24}
        ccMargin="xs none m"
        accessibilityLabel={translate('assetFeed.filterRow.tagFilter.loading')}
        label={translate('assetFeed.filterRow.tagFilter.loading')}
      />
    );
  }

  const selectedTagIds = activeFilterTags.map(({ node_id }) => node_id);

  const toggleTagFilter = (tag) => {
    const nextFilterTags = selectedTagIds.includes(tag.node_id)
      ? activeFilterTags.filter(({ node_id }) => node_id !== tag.node_id)
      : [...activeFilterTags, tag];
    onChange({ tags: nextFilterTags });
  };

  return (
    <TagRowContainer hasTags={tags.length}>
      {tags.map((tag) => {
        const pressed = selectedTagIds.includes(tag.node_id);
        return (
          <ChipToggle
            key={`tag-${tag.id}`}
            pressed={pressed}
            onClick={() => toggleTagFilter(tag)}
            id={tag.id}
            iconName={pressed ? 'check' : 'tag-outline'}
          >
            {truncateText(tag.display_value)}
          </ChipToggle>
        );
      })}
    </TagRowContainer>
  );
};

TagRow.propTypes = {
  projectId: PropTypes.number,
  activeFilterTags: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TagRow;
